import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonaDto } from 'src/app/dto/persona-dto';
import { EvaluacionService } from 'src/app/services/evaluacion.service';
import { LoginService } from 'src/app/services/login.service';
import { PersonaService } from 'src/app/services/persona.service';
import { VerificacionService } from 'src/app/services/verificacion.service';
import Swal from 'sweetalert2';

import { CursoService } from 'src/app/services/curso.service';
import { Periodo } from 'src/app/model/periodo';
import { environment } from 'src/environments/environment';
import { UaaService } from 'src/app/services/uaa.service';
import { HeaderService } from 'src/app/services/header.service';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  url: string = environment.host;
  GrupoUid: number;
  data: PersonaDto = new PersonaDto;
  ocultar: boolean = false;
  isDropdownOpen = false;

  constructor(
    private personaService: PersonaService,
    private validadroService: VerificacionService,
    private rutaActiva: ActivatedRoute,
    private loginService: LoginService,
    private router: Router,
    private evaluacionService: EvaluacionService,
    private cursoService: CursoService,
    private uaaService: UaaService,
    private headerService: HeaderService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.validadroService.validarSiTieneToken();
    this.GrupoUid = this.rutaActiva.snapshot.params.grupo;
    this.datosPersonales()
  }

  datosPersonales() {
    this.personaService.datosPersonales().subscribe(data => {
      this.data = data;

      if (this.data != null) {
        this.ocultar = true;

        if (this.data.periodo && this.data.periodo.codigo) {
          this.obtenerNombrePeriodo(this.data.periodo.codigo);
        } else {
          // Si no tenemos periodo (caso Estudiante), buscarlo en cursos
          this.cursoService.obtenerCursos().subscribe(cursos => {
            if (cursos && cursos.length > 0 && cursos[0].cusros && cursos[0].cusros.curso && cursos[0].cusros.curso.calendario && cursos[0].cusros.curso.calendario.periodo) {
              const codigoPeriodo = cursos[0].cusros.curso.calendario.periodo.codigo;
              if (!this.data.periodo) {
                this.data.periodo = new Periodo();
                this.data.periodo.codigo = codigoPeriodo;
              }
              this.obtenerNombrePeriodo(codigoPeriodo);
            }
          });
        }
      }
    })
  }

  obtenerNombrePeriodo(codigo: number) {
    this.personaService.getPeriodo(codigo).subscribe(nombrePeriodo => {
      if (this.data.periodo) {
        this.data.periodo.nombre = nombrePeriodo;
      }
    });
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  logout() {
    this.onClickCerrarSesion();
  }

  onClickCerrarSesion() {
    const docentesEvaluados = this.evaluacionService.getDocentesEvaluados();

    if (!docentesEvaluados) {
      Swal.fire({
        text: "Debe evaluar a todos los docentes antes de cerrar sesión.",
        iconHtml: '<i class="fas fa-exclamation-triangle"></i>',
        icon: 'warning',
        confirmButtonColor: "#8F141B",
        confirmButtonText: 'Aceptar',
      });
    } else {
      this.cerrarSesionCompleta();
    }
  }

  /** Limpia todo el estado en memoria antes de navegar al login */
  private cerrarSesionCompleta() {
    // Cerrar cualquier dialog de Material abierto (ej: ParesDialogComponent con disableClose:true)
    this.dialog.closeAll();
    this.evaluacionService.reset();
    this.uaaService.reset();
    this.headerService.reset();
    this.loginService.logout(); // ya limpia storage y navega
  }
}
